var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Redirect } from "react-router";
import { Link, NavLink } from "react-router-dom";
import { LOCAL_SHOP_NAV, ORIGIN } from "./Config";
var AppPaths = /** @class */ (function () {
    function AppPaths() {
    }
    // url paths for pages (not backend calls)
    AppPaths.LOG_IN = '/user/log-in';
    AppPaths.LOG_OUT = '/user/log-out';
    AppPaths.REGISTER = '/user/register';
    AppPaths.NEW_REGISTER_PREVIEW = '/user/register-preview';
    AppPaths.PROFILE = '/user/profile';
    AppPaths.ORDERS = '/user/orders/all';
    AppPaths.ORDER_BASE = '/user/orders/id';
    AppPaths.ORDER_PATTERN = AppPaths.ORDER_BASE + "/:id";
    AppPaths.CART = '/cart';
    AppPaths.LOCAL_NEW_KIT = '/new-kit';
    AppPaths.LOCAL_NEW_LEGACY_KIT_RNA_FISH = '/new-kit/v3/rnafish';
    AppPaths.LOCAL_NEW_GOLD_AMPLIFIER = "/new-kit/gold/amplifier";
    AppPaths.LOCAL_NEW_KIT_RNA_FISH = '/new-kit/gold/rnafish';
    AppPaths.LOCAL_NEW_KIT_ENCODER = '/new-kit/gold/if';
    AppPaths.LOCAL_NEW_KIT_IHC2 = '/new-kit/gold/if-secondary';
    AppPaths.LOCAL_NEW_LEGACY_KIT_IHC2 = '/new-kit/v3/if-secondary';
    AppPaths.LOCAL_NEW_KIT_RNA_CISH = '/new-kit/rna-ish';
    AppPaths.LOCAL_NEW_KIT_RNA_CISH_CHROMOGEN = '/new-kit/rna-ish-chromogen';
    AppPaths.LOCAL_NEW_KIT_MANUAL_PRO = '/new-kit/pro/rnaish';
    AppPaths.ORDER_UPLOAD_PO = "/order/upload-purchase-order";
    AppPaths.ADMIN_ORDERS = '/admin/orders/all';
    AppPaths.ADMIN_ORDER_BASE = '/admin/orders/id';
    AppPaths.ADMIN_ORDER_PATTERN = AppPaths.ADMIN_ORDER_BASE + "/:id";
    AppPaths.ADMIN_USERS = '/admin/users/all';
    AppPaths.ADMIN_USER_BASE = '/admin/users/id';
    AppPaths.ADMIN_USER_PATTERN = AppPaths.ADMIN_USER_BASE + "/:id";
    AppPaths.ADMIN_TRACKING = '/admin/tracking';
    AppPaths.ADMIN_RNA_CATALOG = '/admin/catalog/rna';
    AppPaths.ADMIN_PROBE_LOT_TABLE = '/admin/catalog/rna-probes';
    AppPaths.ADMIN_RNA_CATALOG_TABLE = '/admin/catalog/rna-table';
    AppPaths.ADMIN_RNA_CISH_STARTER_KIT = '/admin/rna-cish-starter-kit-page';
    AppPaths.ADMIN_MANUAL_STARTER_KIT = '/admin/manual-starter-kit-page';
    AppPaths.ADMIN_REPORTS = '/admin/reports';
    AppPaths.ADMIN_RNA_CISH_KIT = '/admin/new-kit/rna-ish';
    AppPaths.MARKETING_REFERRALS = '/admin/marketing-referrals';
    AppPaths.AUTOMATED_GOLD_IF_PRESET_SCALES_PAGE = '/admin/automated-gold-if-scale';
    AppPaths.ADMIN_INVENTORY = '/admin/inventory';
    AppPaths.ADMIN_PRESET_SCALES = '/admin/preset-scales';
    AppPaths.ADMIN_STARTER_KITS = '/admin/starter-kits';
    AppPaths.ADMIN_FLUORESCENT_HAIRPIN_TRACKING = '/admin/fluorescent-hairpin/tracking';
    AppPaths.ADMIN_MANUAL_BUFFER_TRACKING = '/admin/manual-buffer/tracking';
    AppPaths.ADMIN_ENCODER_TRACKING = '/admin/encoder/tracking';
    AppPaths.ADMIN_SECONDARY_IF_PROBE_TRACKING = '/admin/secondary-if-probe/tracking';
    AppPaths.ADMIN_AUTOMATED_IF_PRESET_SCALES = '/admin/automated-if/preset-reagent-scales';
    AppPaths.ADMIN_PRO_PROBE_PRESET_SCALES = '/admin/pro-probe/preset-scales';
    AppPaths.ADMIN_PRO_DETECT_PRESET_SCALES = '/admin/pro-detect/preset-scales';
    AppPaths.ADMIN_CHROMOGEN_PRESET_SCALES = '/admin/chromogen/preset-scales';
    return AppPaths;
}());
export { AppPaths };
export var defaultUiConfig = function () { return ({
    authenticated: false,
    uiFeatures: new Set(),
    isDefault: true,
    userStatus: "NON_LEGACY",
    academic: false
}); };
export var UiConfigContext = React.createContext(defaultUiConfig());
export var FEATURE_CREATE_ORDER_FOR_USER = 'adminCreateOrderForUser';
var AuthnObserver = /** @class */ (function () {
    function AuthnObserver(callback) {
        var _this = this;
        this.onAuthnStateChanged = function () {
            _this.callback();
        };
        this.callback = callback;
    }
    return AuthnObserver;
}());
export { AuthnObserver };
export var useMarketingSite = LOCAL_SHOP_NAV !== '1';
export var marketingSiteShopPage = ORIGIN === "mi" ?
    'https://www.molecularinstruments.com/shop' :
    window.location.origin + "/new-kit/rna-ish";
// When navigating to shop-related paths, on prod it should go to mi.com/shop
var ShopLink = /** @class */ (function (_super) {
    __extends(ShopLink, _super);
    function ShopLink(props) {
        return _super.call(this, props) || this;
    }
    ShopLink.prototype.render = function () {
        if (useMarketingSite) {
            if (this.props.marginRight) {
                return React.createElement("a", { style: { marginRight: this.props.marginRight }, href: marketingSiteShopPage }, this.props.children);
            }
            else {
                return React.createElement("a", { href: marketingSiteShopPage }, this.props.children);
            }
        }
        else {
            if (this.props.navLink) {
                if (this.props.marginRight) {
                    return React.createElement(NavLink, { style: { marginRight: this.props.marginRight }, to: this.props.to }, this.props.children);
                }
                else {
                    return React.createElement(NavLink, { to: this.props.to }, this.props.children);
                }
            }
            else {
                return React.createElement(Link, { to: this.props.to }, this.props.children);
            }
        }
    };
    return ShopLink;
}(React.PureComponent));
export { ShopLink };
// The internal redirect from / to /new-kit should go to mi.com/shop on prod
var ShopRedirect = /** @class */ (function (_super) {
    __extends(ShopRedirect, _super);
    function ShopRedirect(props) {
        return _super.call(this, props) || this;
    }
    ShopRedirect.prototype.componentDidMount = function () {
        if (useMarketingSite) {
            window.location.href = marketingSiteShopPage;
        }
    };
    ShopRedirect.prototype.render = function () {
        return React.createElement(Redirect, { to: AppPaths.LOCAL_NEW_KIT });
    };
    return ShopRedirect;
}(React.PureComponent));
export { ShopRedirect };
var RedirectEncoder = /** @class */ (function (_super) {
    __extends(RedirectEncoder, _super);
    function RedirectEncoder(props) {
        return _super.call(this, props) || this;
    }
    RedirectEncoder.prototype.componentDidMount = function () {
        window.location.href = 'https://www.molecularinstruments.com/hcr-gold-if';
    };
    RedirectEncoder.prototype.render = function () {
        return null;
    };
    return RedirectEncoder;
}(React.PureComponent));
export { RedirectEncoder };
//# sourceMappingURL=AppConfig.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/AppConfig.js
// module id = 18
// module chunks = 0